import { mq } from '@kvdbil/components';
import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div<{ isSticky: boolean }>`
  display: ${({ isSticky }) => (isSticky ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;

  ${mq(null, 'tablet')} {
    bottom: 0;
    top: unset;
  }
`;

interface Props {
  stickyCondition: () => boolean;
  isDisabled?: boolean;
  onSticky?: (isSticky: boolean) => void;
  style?: CSSProperties;
  children: ReactNode;
}

export const StickyOnScrollContainer = ({
  stickyCondition,
  isDisabled = false,
  onSticky,
  children,
  style
}: Props) => {
  const [isScrolledPast, setScrolledPast] = useState(false);
  const isSticky = isScrolledPast && !isDisabled;

  useEffect(() => {
    const handleScroll = () => {
      if (stickyCondition?.()) {
        setScrolledPast(true);
        return;
      }
      setScrolledPast(false);
    };

    window.addEventListener('scroll', handleScroll, false);

    return () => {
      window.removeEventListener('scroll', handleScroll, false);
    };
  }, [stickyCondition]);

  useEffect(() => {
    onSticky && onSticky(isSticky);
  }, [isSticky, onSticky]);

  return (
    <Container isSticky={isSticky} style={style}>
      {children}
    </Container>
  );
};
